'use client';

import { useEffect } from 'react';
import { LUMIERE_KEY, autoriserLumiere, demarrerLumiere, readLumiere, saveLumiere } from '@/lib/lumiere';

/**
 * L'écoute de la lumière vivante (lib/lumiere.ts), montée une fois dans
 * AppShell. Elle suit l'interrupteur des Paramètres, et ne fait rien pour qui
 * a demandé moins d'animations à son téléphone.
 */
export function LumiereVivante() {
  useEffect(() => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let arret: (() => void) | null = null;
    // iPhone : sans autorisation, l'écoute ne reçoit rien. Elle ne se demande
    // que sur un geste — le premier appui de la session ; une fois accordée,
    // iOS répond sans rien afficher.
    const demander = async () => { if (!(await autoriserLumiere())) saveLumiere('off'); };
    const suivre = () => {
      arret?.();
      arret = null;
      document.removeEventListener('click', demander);
      if (readLumiere() !== 'on') return;
      arret = demarrerLumiere();
      document.addEventListener('click', demander, { once: true });
    };
    suivre();
    window.addEventListener(LUMIERE_KEY, suivre);
    return () => {
      window.removeEventListener(LUMIERE_KEY, suivre);
      document.removeEventListener('click', demander);
      arret?.();
    };
  }, []);
  return null;
}
